import type { LessonWordGroup, LessonWordWord } from '@/types'

export function lessonWordTranslation(word?: LessonWordWord): string {
  const attr = word?.attributes?.find((item) => item.key === 'translation')
  return attr?.value?.trim() ?? ''
}

export function lessonWordTranscription(word?: LessonWordWord): string {
  const attr = word?.attributes?.find((item) => item.key === 'transcription')
  return attr?.value?.trim() ?? ''
}

export function lessonWordOriginal(word?: LessonWordWord): string {
  return word?.text?.trim() ?? ''
}

export function isLessonWordGroupIncomplete(group: LessonWordGroup): boolean {
  if (group.incomplete) return true
  const word = group.word
  return lessonWordTranslation(word) === '' || lessonWordTranscription(word) === ''
}

export function lessonWordGroupNeedsCompletion(groups: LessonWordGroup[]): boolean {
  return groups.some((group) => isLessonWordGroupIncomplete(group))
}
